import { createFileRoute, useNavigate, useRouterState, useSearch } from '@tanstack/react-router'
import { useCallback } from 'react'
import AutomaticSheet from 'src/components/sheet/AutomaticSheet'

import { useTranslation } from 'react-i18next'
import { Result, SearchSelect } from 'src/components/SearchSelect'

export const Route = createFileRoute('/plan/select')({
    component: PlanSelect,
})

function PlanSelect() {
    const navigate = useNavigate()
    const { t } = useTranslation()
    // const state = useRouterState()

    const selectType = useSearch({ select: s => s.selectType })
    const state = useRouterState()
    const { planSearch } = state.location.state

    console.debug('STATE', state)

    const onClick = useCallback((result: Result) => {
        const selected: Result = { latitude: result.location?.latitude, longitude: result.location?.longitude, title: result.title, type: 'POI' }
        navigate({
            to: '/plan',
            search: { ...planSearch, [selectType]: selected },
        })
    }, [selectType, navigate, planSearch])

    return (
        <AutomaticSheet>
            <title>{t('Select location')}</title>
            <SearchSelect onSelect={(onClick)} />
        </AutomaticSheet>
    )
}
